import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import { Sidebar } from 'primereact/sidebar';
import { Identifier } from '@utils/utils';
import { NotificationTypeSettingOutDTO } from '@api/ringil-api.v2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { sidebarTransitionOptions } from '@components/ringil3/Sidebar/sidebarTransition.ts';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  companyId: Identifier;
}

const EmailPreferencesV2Dialog: React.FC<ComponentProps> = ({ onHide, visible, companyId }) => {
  const { adminGetCompanyNotificationTypeSettings, adminSetCompanyNotificationTypeSetting } = useContext(ApiContext);
  const [settings, setSettings] = useState<NotificationTypeSettingOutDTO[]>([]);
  const { tr } = useTranslationLgs();

  useEffect(() => {
    if (visible) {
      load();
    }
  }, [companyId, visible]);

  const load = () => {
    adminGetCompanyNotificationTypeSettings(companyId, d => {
      setSettings(d);
    });
  };

  const changeSetting = (row: NotificationTypeSettingOutDTO, email: boolean, notificationCenter: boolean) => {
    // Optimistic update so a quick second toggle does not read stale values
    setSettings(prev => prev.map(s => (s.emailType === row.emailType ? { ...s, email, notificationCenter } : s)));
    adminSetCompanyNotificationTypeSetting(companyId, { emailType: row.emailType, email, notificationCenter }, () => {
      load();
    });
  };

  return (
    <>
      {/*// @ts-ignore*/}
      <Sidebar transitionOptions={sidebarTransitionOptions} onHide={onHide} visible={visible} position={'right'} style={{ minWidth: '40rem' }}>
        <h1>{tr(`EmailPreferencesV2Dialog.title`, `Notifications`)}</h1>
        {/*// @ts-ignore*/}
        <DataTable value={settings} emptyMessage={tr(`global.noRecordFound`, `Nebyly nalezeny žádné záznamy`)}>
          <Column
            header={tr(`EmailPreferencesV2Dialog.notificationType`, `Notification type`)}
            body={(row: NotificationTypeSettingOutDTO) => (
              <div>
                <div>{row.emailType}</div>
                <div className={'text-gray-500 text-sm'}>{row.title}</div>
              </div>
            )}
          />
          <Column
            style={{ width: '5rem' }}
            header={tr(`EmailPreferencesV2Dialog.email`, `Email`)}
            body={(row: NotificationTypeSettingOutDTO) => <InputSwitch checked={row.email} onChange={e => changeSetting(row, e.value, row.notificationCenter)} />}
          />
          <Column
            style={{ width: '5rem' }}
            header={tr(`EmailPreferencesV2Dialog.notificationCenter`, `Notification center`)}
            body={(row: NotificationTypeSettingOutDTO) => <InputSwitch checked={row.notificationCenter} onChange={e => changeSetting(row, row.email, e.value)} />}
          />
        </DataTable>
        <Button label={tr(`EmailPreferencesV2Dialog.close`, `Close`)} onClick={e => onHide()}></Button>
      </Sidebar>
    </>
  );
};

export default EmailPreferencesV2Dialog;
